// A factory, so a reset is the same operation as a fresh start.
const createState = () => ({
    conversationId: null,
    clientId: null,

    // Built locally from each turn's `replies`, which carries every line the
    // assistant said in order — including anything said before a tool ran.
    messages: [],

    // What the manager just sent, held until the turn comes back.
    outgoing: null,

    turnState: null,
    pending: null,
    clientCandidates: [],

    // v1 WigFullResource.
    wig: null,

    isSending: false,

    failure: null,

    // Sticky for the session: only a reload brings a switched-off assistant back.
    isSwitchedOff: false,

    // Kept so a turn lost to a silent gateway can be sent again as it was.
    lastTurn: null,
})

export default createState
